exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VehiclePOICrossingsSummaries{\r\n\twidth: 100%;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .Card{\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .Card:nth-last-child(){\r\n\tmargin-bottom: 0px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/view/VehiclePOICrossingsSummaries/VehiclePOICrossingsSummaries.css
// module id = 744
// module chunks = 0